import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
import arrowLeft from 'open-iconic/svg/arrow-left.svg';
import { ListGroupItem } from 'reactstrap';

import FolderAndPageList from 'app/FolderAndPageList/components/FolderAndPageList';
import { PUBLISHED } from 'lib/versions';
import { IconButton } from 'ui/Components';
import { folder } from 'ui/Icons';

import styles from './Tree.css';

import { MENU_ACTION_DUPLICATE, MENU_ACTION_UNFAVORITE } from '../const';

const favoriteFoldersAndPagesId = 'favorite-folders-and-pages';
const favoriteFoldersAndPagesName = 'Favorite Folders & Pages';
const favoriteFoldersId = 'favorite-folders';
const favoritePagesId = 'favorite-pages';
const defaultState = [
  { Id: favoriteFoldersId, Name: 'Favorite Folders', Type: 'folder' },
  { Id: favoritePagesId, Name: 'Favorite Pages', Type: 'folder' }
];

/**
 * render the contents of a favorite Folders and Pages
 */
class FavoriteFoldersAndPages extends Component {
  static propTypes = {
    favoriteFolders: propTypes.arrayOf(propTypes.shape()),
    favoritePages: propTypes.arrayOf(propTypes.shape()),
    onActionSelect: propTypes.func.isRequired,
    onItemSelect: propTypes.func.isRequired
  };

  static defaultProps = {
    favoriteFolders: [],
    favoritePages: []
  };

  constructor(props) {
    super(props);
    this.state = {
      actions: undefined,
      currentSelectedId: favoriteFoldersAndPagesId
    };

    this.onFavoriteSelect = this.onFavoriteSelect.bind(this);
  }

  onFavoriteSelect(item) {
    const { onItemSelect } = this.props;

    switch (item.Id) {
      case favoriteFoldersAndPagesId:
        this.setState({
          actions: undefined,
          currentSelectedId: item.Id
        });
        break;
      case favoriteFoldersId:
        this.setState({
          actions: [MENU_ACTION_UNFAVORITE],
          currentSelectedId: item.Id
        });
        break;
      case favoritePagesId:
        this.setState({
          actions: [MENU_ACTION_DUPLICATE, MENU_ACTION_UNFAVORITE],
          currentSelectedId: item.Id
        });
        break;
      default:
        onItemSelect(item);
        break;
    }
  }

  get getFavoriteContent() {
    const { favoriteFolders, favoritePages } = this.props;
    const { currentSelectedId } = this.state;
    switch (currentSelectedId) {
      case favoriteFoldersId:
        return favoriteFolders.map(f => ({ ...f, Type: 'folder' }));
      case favoritePagesId:
        return favoritePages.map(f => ({
          ...f,
          Version: PUBLISHED,
          Name: f.PageName,
          Type: 'page'
        }));
      default:
        return defaultState;
    }
  }

  get getSelectedFolder() {
    const { currentSelectedId } = this.state;
    const selectedFolder = defaultState.find(i => i.Id === currentSelectedId) || {};
    return selectedFolder.Name || favoriteFoldersAndPagesName;
  }

  render() {
    const { onActionSelect } = this.props;
    const { currentSelectedId } = this.state;

    const { actions } = this.state;
    return (
      <Fragment>
        <ListGroupItem className={styles.topItem}>
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <IconButton alt="Folder" icon={folder} rem={2.3} noMargin />
              <span className={styles.cwdName} title={this.getSelectedFolder}>
                {this.getSelectedFolder}
              </span>
            </div>
            <IconButton
              alt={`Back to ${favoriteFoldersAndPagesName}`}
              className={styles.listElem}
              data-test-id="favoriteFoldersAndPages-backButton"
              hidden={currentSelectedId === favoriteFoldersAndPagesId}
              icon={arrowLeft}
              onClick={() => this.onFavoriteSelect({ Id: favoriteFoldersAndPagesId })}
              rem={2}
              noMargin
            />
          </div>
        </ListGroupItem>
        {this.getFavoriteContent.length ? (
          <FolderAndPageList
            foldersAndPages={this.getFavoriteContent}
            onItemSelect={this.onFavoriteSelect}
            itemActions={actions}
            onActionSelect={onActionSelect}
          />
        ) : (
          `Please mark some ${this.getSelectedFolder}.`
        )}
      </Fragment>
    );
  }
}

export default FavoriteFoldersAndPages;
